import React from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Stack, Typography, useTheme } from '@mui/material';

import DrawerBody from './DrawerBody';
import DrawerContainer from './DrawerContainer';
import DrawerTitle from './DrawerTitle';

export interface CareTaskDetailDrawerProps {
    careTaskName: string;
    heading: string;
    children: React.ReactNode;
    careTaskIcon?: IconProp;
    careTaskScheduledAt?: string;
    open: boolean;
    onClose: () => void;
}

const CareTaskDetailDrawer = ({
    careTaskName,
    heading,
    children,
    careTaskIcon,
    careTaskScheduledAt,
    open,
    onClose,
}: CareTaskDetailDrawerProps) => {
    const { palette, shape } = useTheme();
    const { gray, neutral } = palette;

    return (
        <DrawerContainer
            open={open}
            onClose={onClose}
            anchor="bottom"
            paperSx={{
                borderTopLeftRadius: shape.borderRadiusXl,
                borderTopRightRadius: shape.borderRadiusXl,
            }}
        >
            <DrawerTitle sx={{ pt: 2, px: 2 }}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    size="small"
                    disableRipple
                    sx={{ alignSelf: 'flex-end', p: 0 }}
                >
                    <FontAwesomeIcon icon={faTimes} color={gray?.[900]} size="lg" />
                </IconButton>
                <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
                    {careTaskIcon && <FontAwesomeIcon icon={careTaskIcon} size="2x" fixedWidth />}
                    <Stack>
                        <Typography
                            variant="body1"
                            sx={{ fontWeight: 'bold', wordBreak: 'break-word' }}
                        >
                            {careTaskName}
                        </Typography>
                        <Typography variant="body2" sx={{ color: neutral[500] }}>
                            {careTaskScheduledAt}
                        </Typography>
                    </Stack>
                </Stack>
            </DrawerTitle>
            <DrawerBody sx={{ pt: 2, px: 2, pb: 4, gap: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {heading}
                </Typography>
                {children}
            </DrawerBody>
        </DrawerContainer>
    );
};

export default CareTaskDetailDrawer;
